import React from 'react';
import { Line } from 'react-chartjs-2';
import { Paper, Typography, Box } from '@mui/material';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  TimeScale,
} from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import dayjs from 'dayjs';
import 'chartjs-adapter-dayjs-4/dist/chartjs-adapter-dayjs-4.esm';
import {
  CHART_DEFAULTS,
  THEME_CONFIG,
  SERIES_COLORS,
  createChartOptions,
  formatChartData,
  getSeriesColor
} from '../utility/graph';

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  TimeScale,
  zoomPlugin
);

export const TrendChart = ({ data, title, height = CHART_DEFAULTS.height }) => {
  // Convert data format for Chart.js using helper function
  const chartData = formatChartData(data);

  // Create chart options using configuration factory
  const options = createChartOptions();

  return (
    <Paper elevation={THEME_CONFIG.paper.elevation} sx={{
      p: THEME_CONFIG.paper.padding,
      mb: THEME_CONFIG.paper.marginBottom,
      border: THEME_CONFIG.paper.border
    }}>
      <Typography
        variant={THEME_CONFIG.typography.title.variant}
        gutterBottom={THEME_CONFIG.typography.title.gutterBottom}
        sx={{ mb: THEME_CONFIG.typography.title.marginBottom }}
      >
        {title}
      </Typography>
      <Typography
        variant={THEME_CONFIG.typography.instruction.variant}
        color={THEME_CONFIG.typography.instruction.color}
        sx={{ mb: THEME_CONFIG.typography.instruction.marginBottom }}
      >
        {THEME_CONFIG.typography.instruction.text}
      </Typography>
      <Box
        sx={{
          height: height,
          ...THEME_CONFIG.chartContainer
        }}
      >
        <Line data={chartData} options={options} />
      </Box>
    </Paper>
  );
};
